import React from 'react';
import { createBearerAuthorization } from './UiSurfaceBoundary';
import {
  SAFE_LEGACY_ROUTE,
  saveUiSurfacePreference,
} from './uiSurfaceBootstrap';
import { markUiSurfaceEntryAttempt } from './uiSurfaceEntryAttempt';

export default class UiUxPilotErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, recoveryStatus: 'idle' };
  }

  static getDerivedStateFromError() {
    return { hasError: true, recoveryStatus: 'idle' };
  }

  componentDidCatch() {
    const {
      authenticatedUser,
      expectedReleaseId,
      sessionStorageObject = typeof window === 'undefined' ? null : window.sessionStorage,
    } = this.props;
    markUiSurfaceEntryAttempt(
      sessionStorageObject,
      expectedReleaseId,
      authenticatedUser?.id,
    );
  }

  recoverLegacyPreference = async () => {
    const {
      authenticatedUser,
      token,
      expectedReleaseId,
      fetchImpl,
      timeoutMs = 5_000,
      locationObject = typeof window === 'undefined' ? null : window.location,
    } = this.props;
    this.setState({ recoveryStatus: 'saving' });
    const decision = await saveUiSurfacePreference({
      preference: 'legacy',
      authenticatedUser,
      authHeader: createBearerAuthorization(token),
      fetchImpl,
      timeoutMs,
    });
    const confirmed = decision?.safeFallback !== true
      && decision?.effectiveSurface === 'legacy'
      && decision?.releaseId === expectedReleaseId;
    if (!confirmed || typeof locationObject?.assign !== 'function') {
      this.setState({ recoveryStatus: 'failed' });
      return;
    }
    try {
      locationObject.assign(SAFE_LEGACY_ROUTE);
    } catch (_error) {
      this.setState({ recoveryStatus: 'failed' });
    }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main
        role="alert"
        aria-live="assertive"
        className="min-h-screen bg-slate-50 px-6 py-16 text-slate-900"
      >
        <div className="mx-auto max-w-xl rounded-2xl border border-rose-200 bg-white p-8 shadow-lg">
          <p className="mb-2 text-sm font-bold text-rose-700">新しい画面・確認版</p>
          <h1 className="mb-3 text-2xl font-bold">新しい画面を読み込めませんでした</h1>
          <p className="mb-6 text-sm leading-6 text-slate-600">
            旧画面には影響ありません。画面設定を戻してから、以前の画面を開いてください。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              className="min-h-11 rounded-lg bg-rose-600 px-4 py-2 text-sm font-bold text-white focus:outline-none focus:ring-4 focus:ring-rose-200 disabled:opacity-70"
              disabled={this.state.recoveryStatus === 'saving'}
              onClick={this.recoverLegacyPreference}
            >
              {this.state.recoveryStatus === 'saving' ? '画面設定を戻しています…' : '画面設定を戻して旧画面へ'}
            </button>
            <a
              className="inline-flex min-h-11 items-center justify-center rounded-lg border border-slate-300 px-4 py-2 text-sm font-bold text-slate-700 focus:outline-none focus:ring-4 focus:ring-slate-200"
              href={SAFE_LEGACY_ROUTE}
            >
              旧画面を開く
            </a>
          </div>
          {this.state.recoveryStatus === 'failed' && (
            <p className="mt-4 text-sm text-rose-700">
              画面設定を保存できませんでした。上の「旧画面を開く」から以前の画面を利用できます。
            </p>
          )}
        </div>
      </main>
    );
  }
}
